const PrivacyPolicy = () => {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "40px auto",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
        color: "#333",
        backgroundColor: "#fff",
      }}
    >
      <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
        Privacy Policy
      </h1>

      <p>
        <strong>Darshan Printing Ledger</strong> (“the App”) is designed to display
        transaction-related information for reference purposes only. We respect
        your privacy and are committed to protecting it.
      </p>

      <h3>Information Collection and Use</h3>
      <p>Darshan Printing Ledger does not collect, store, or process any personal data.</p>
      <ul>
        <li>No user registration or login is required</li>
        <li>No personal information is collected</li>
        <li>No device identifiers or analytics data are collected</li>
      </ul>

      <h3>Transaction Data</h3>
      <ul>
        <li>The App is used only to display transaction records</li>
        <li>All transaction data is read-only</li>
        <li>No transaction data is created, modified, or stored</li>
        <li>No data is shared with third parties</li>
      </ul>

      <h3>Data Storage</h3>
      <p>
        The App does not store any personal or sensitive user data on the device
        or on external servers.
      </p>

      <h3>Third-Party Services</h3>
      <p>
        Darshan Printing Ledger does not use third-party analytics, advertising,
        or tracking services.
      </p>

      <h3>Data Security</h3>
      <p>
        Since no personal data is collected, there is no risk of personal data
        misuse through the App.
      </p>

      <h3>Children’s Privacy</h3>
      <p>
        The App does not collect information from children under the age of 13
        and is safe for users of all ages.
      </p>

      <h3>Changes to This Policy</h3>
      <p>
        This Privacy Policy may be updated from time to time. Any changes will be
        posted on this page.
      </p>

      <h3>Contact Us</h3>
      <p>
        If you have any questions about this Privacy Policy, contact us at:
      </p>
      <p>
        <strong>Email:</strong> info@arramton.com <br />
        <strong>Company:</strong> Darshan Printing
      </p>
    </div>
  );
};

export default PrivacyPolicy;
